import React from "react";
import injectSheet from "react-jss";
import { TopStep } from "../../";
import { Forward } from "../../icons/chevronRight";

const TopStepper = (props) => {
  const { classes, currentPath, history, incomplete, steps } = props;

  return (
    <div className={classes.container}>
      <ul className={classes.stepperList}>
        {steps &&
          steps.length &&
          steps.map((step, index) => (
            <TopStep
              active={currentPath.join("/") === step.config.path}
              activated={
                incomplete < steps.length
                  ? index <= incomplete
                  : index + 1 === steps.length
              }
              complete={index <= incomplete}
              history={history}
              index={index}
              key={`topStep-${step.config.title}`}
              last={index === steps.length - 1}
              path={`/${step.config.path}`}
              title={step.config.title}
              trail={currentPath.includes(step.config.path)}
            />
          ))}
        <TopStep
          active={false}
          activated={true}
          history={history}
          index={steps.length}
          key={`topStep-complete`}
          last
          title="Abschluss"
          trailing
          icon={<Forward />}
          onClick={() => {
            const ok = window.confirm("Wollen Sie den Assistenten vorzeitig beenden?");

            if (ok) {
              history.push("/angebot-anfordern");
            }
          }}
        />
      </ul>
    </div>
  );
};

const styles = (theme) => ({
  container: {
    backgroundColor: theme.colors.main,
    zIndex: 1,
  },
  stepperList: {
    listStyleType: "none",
    margin: 0,
    padding: `0 ${theme.sizes.gutter / 2}px ${theme.sizes.gutter / 2}px ${theme.sizes.gutter / 2}px`,
    display: "flex",
    justifyContent: "center",
    [theme.media.medium]: {
      padding: `0 ${theme.sizes.gutter / 2}px ${theme.sizes.gutter}px ${theme.sizes.gutter / 2}px`,
    },
  },
});

export default injectSheet(styles)(TopStepper);



// WEBPACK FOOTER //
// ./src/modules/core/components/topStepper.jsx